import { useConfig } from '../../../Providers/ConfigProvider'
import { useShop } from '../../../Providers/ShopProvider'
import { GetProductsCountForNoCategoryActive } from '../../../Services/ProductService'

const useGetProductsCountForNoCategoryActive = () => {
    const { api } = useConfig()
    const { productsFilter } = useShop()

    const handleGetProductsCountForNoCategoryActive = async () => {
        try {
            const res = await GetProductsCountForNoCategoryActive(api, productsFilter)
            return res.data
        } catch (error) {
            console.log(error)
            return 0
        }
    }

    return { handleGetProductsCountForNoCategoryActive }
}

export default useGetProductsCountForNoCategoryActive